/**
 * Generated by orval 🍺
 * Do not edit manually.
 * IST.Connect | v1
 * REST API backing the IST Connect web frontend. Provides endpoints to manage plugin configurations and inspect task execution results, logs, and dashboard data.
 * OpenAPI spec version: 1.0.0
 */
import type { GetExecutionLogsParams, GetTasksParams, LogPage, TaskPage } from "../model";

import { customFetch } from "../../customFetcher";

export const getGetExecutionLogsUrl = (id: string, params?: GetExecutionLogsParams) => {
	const normalizedParams = new URLSearchParams();

	Object.entries(params || {}).forEach(([key, value]) => {
		if (value !== undefined) {
			normalizedParams.append(key, value === null ? "null" : String(value));
		}
	});

	const stringifiedParams = normalizedParams.toString();

	return stringifiedParams.length > 0
		? `/istconnect-service-api/tasks/${id}/execution-logs?${stringifiedParams}`
		: `/istconnect-service-api/tasks/${id}/execution-logs`;
};

/**
 * @summary Get logs for a tasks
 */
export const getExecutionLogs = async (id: string, params?: GetExecutionLogsParams, options?: Parameters<typeof customFetch>[1]): Promise<LogPage> => {
	return customFetch<LogPage>(getGetExecutionLogsUrl(id, params), {
		...options,
		method: "GET",
	});
};

export const getGetTasksUrl = (params?: GetTasksParams) => {
	const normalizedParams = new URLSearchParams();

	Object.entries(params || {}).forEach(([key, value]) => {
		if (value !== undefined) {
			normalizedParams.append(key, value === null ? "null" : String(value));
		}
	});

	const stringifiedParams = normalizedParams.toString();

	return stringifiedParams.length > 0 ? `/istconnect-service-api/tasks?${stringifiedParams}` : `/istconnect-service-api/tasks`;
};

/**
 * @summary Get all tasks
 */
export const getTasks = async (params?: GetTasksParams, options?: Parameters<typeof customFetch>[1]): Promise<TaskPage> => {
	return customFetch<TaskPage>(getGetTasksUrl(params), {
		...options,
		method: "GET",
	});
};
